import { FC, PropsWithChildren } from 'react';

import { IonItem, IonLabel } from '@ionic/react';
import { useContextSelector } from 'use-context-selector';

import { Icon, IconName } from '../../../Icon';
import { ActionSheetMenuContext } from '../ActionSheetMenu.context';

import style from './ActionSheetMenuItem.module.scss';

export type ActionSheetMenuItemProps = PropsWithChildren<{
  icon?: IconName;
  onClick?: () => void;
}>;

export const ActionSheetMenuItem: FC<ActionSheetMenuItemProps> = ({
  icon,
  children,
  onClick,
}) => {
  const dismiss = useContextSelector(
    ActionSheetMenuContext,
    ({ dismiss }) => dismiss
  );

  const handleOnClick = () => {
    onClick();
    dismiss();
  };

  return (
    <IonItem lines="full" onClick={handleOnClick} button>
      <IonLabel className={style.label}>{children}</IonLabel>
      {!!icon && (
        <div slot="end">
          <Icon name={icon} />
        </div>
      )}
    </IonItem>
  );
};
